import {
    BasicPageWrapper,
    DesignTokens,
    GivelifyLabel,
    GivelifyLink,
    GivelifyNotification,
    GivelifyRadio,
} from '@givelify/ui';
import { PAGE_NAME, TrackingProvider } from '@givelify/utils';
import { webConfig } from 'webConfig';
import { ConfirmDialog, FeesInfoBox } from './components';
import {
    CoveredFeesContainer,
    CoveredFeesContent,
    CoveredFeesRadioContainer,
    CoveredFeesRow,
} from './styles';
import { useCoveredFees } from './useCoveredFees';

export const CoveredFees = () => {
    const {
        copy,
        enabled,
        showConfirmation,
        onEnable,
        onDisable,
        onConfirm,
        onCancel,
    } = useCoveredFees();
    return (
        <TrackingProvider
            trackPageVisit
            pageName={PAGE_NAME.SettingsCoveredFees}
        >
            <BasicPageWrapper contentWrapper="simple" title={copy.title}>
                <GivelifyNotification
                    open
                    id="covered-fees-notification"
                    text={
                        <GivelifyLabel variant="body2B">
                            {copy.notification}
                            <GivelifyLink
                                href={webConfig.supportCoveredFees}
                                id="learn-more-link"
                                name="learn_more"
                                target="_blank"
                                test-id="learn-more-link"
                                text={copy.learnMore}
                                variant="body2B"
                            />
                        </GivelifyLabel>
                    }
                    variant="warning"
                />
                <CoveredFeesContainer>
                    <CoveredFeesContent>
                        <CoveredFeesRow>
                            <GivelifyLabel
                                fontWeight={800}
                                text={copy.askDonors}
                                variant="heading2S"
                            />
                            <GivelifyLabel
                                text={copy.description}
                                variant="body1"
                            />
                        </CoveredFeesRow>
                        <CoveredFeesRow>
                            <CoveredFeesRadioContainer
                                id="yes-radio-button"
                                onClick={onEnable}
                                test-id="yes-radio-button"
                            >
                                <GivelifyRadio
                                    aria-label="Yes"
                                    checked={enabled}
                                    id="yes-radio"
                                    onChange={onEnable}
                                    test-id="yes-radio"
                                />
                                <GivelifyLabel
                                    lineHeight="16px"
                                    paddingTop="4px"
                                    text={copy.yes}
                                    variant="body1"
                                />
                            </CoveredFeesRadioContainer>
                            <CoveredFeesRadioContainer
                                id="no-radio-button"
                                onClick={onDisable}
                                test-id="no-radio-button"
                            >
                                <GivelifyRadio
                                    aria-label="No"
                                    checked={!enabled}
                                    id="no-radio"
                                    onChange={onDisable}
                                    test-id="no-radio"
                                />
                                <GivelifyLabel
                                    lineHeight="16px"
                                    paddingTop="4px"
                                    text={copy.no}
                                    variant="body1"
                                />
                                <GivelifyLabel
                                    color={DesignTokens.color.textSecondary}
                                    lineHeight="16px"
                                    paddingTop="4px"
                                    text={copy.recommended}
                                    variant="body1"
                                />
                            </CoveredFeesRadioContainer>
                        </CoveredFeesRow>
                    </CoveredFeesContent>
                    <FeesInfoBox />
                </CoveredFeesContainer>
            </BasicPageWrapper>
            <ConfirmDialog
                id="confirm-dialog"
                onClose={onCancel}
                onConfirm={onConfirm}
                open={showConfirmation}
                test-id="confirm-dialog"
            />
        </TrackingProvider>
    );
};
